import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  reportDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundColor: theme.evPalette.charcoal[100],
  },
  orderDetailsPaper: {
    display: 'flex',
    flex: 1,
    '@media (min-width: 640px)': {
      flexDirection: 'column',
      margin: '16px 24px',
    },
  },
  orderDetailsHeading: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '36px',
    textTransform: 'capitalize',
    '& div': {
      whiteSpace: 'unset !important',
      verticalAlign: 'text-top',
    },
    '@media (max-width: 640px)': { display: 'contents' },
  },
  orderDetailsContainer: {
    columnGap: '24px',
    flexDirection: 'column',
    '@media (min-width: 1024px)': {
      flexDirection: 'column',
    },
    '@media (max-width: 640px)': {
      padding: '0',
    },
  },
  buildingsHeading: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    padding: '24px 0 16px 0',
  },
  buildingChip: {
    verticalAlign: 'text-top',
  },
  orderDetailsHeaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[200]}`,
    padding: '16px 24px',
    '@media (min-width: 640px)': {
      flex: 1,
    },
  },
  orderDetailsFiles: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '16px',
    '& span,p,label': {
      fontSize: '14px',
      lineHeight: '19px',
    },
    '& .heading': {
      fontWeight: 600,
      fontSize: '18px',
      lineHeight: '27px',
    },
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
  orderDetailsContent: {
    display: 'flex',
    padding: '16px 24px',
    flex: 1,
    gap: '40px',
    flexDirection: 'column-reverse',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
  orderDetailsListItem: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '16px',
    '&.borderBottom': {
      paddingBottom: '26px',
      borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
    },
    '&>div': {
      flexWrap: 'nowrap',
      rowGap: '8px',
      gap: '18px',
      '@media (min-width: 1024px)': {
        alignItems: 'center',
      },
    },
    '&>div>p': {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      color: theme.evPalette.charcoal[900],
      minWidth: '120px',
      '&.bold': { fontWeight: 600 },
      '&:first-child': {
        '@media (min-width: 640px)': { width: '120px' },
        color: theme.evPalette.charcoal[600],
        fontFamily: 'Noto Sans',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '24px',
      },
    },
    '&>div>div': {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      color: theme.evPalette.charcoal[900],
      minWidth: '120px',
      '&.bold': { fontWeight: 600 },
      '&:first-child': {
        '@media (min-width: 640px)': { width: '120px' },
        color: theme.evPalette.charcoal[600],
        fontFamily: 'Noto Sans',
      },
    },
  },
  filesDropdownBtn: {
    minWidth: 'unset',
    padding: '4px 8px 4px 16px',
    height: '32px',
    gap: '8px',
    borderLeft: `1px solid ${theme.evPalette.salt[100]}`,
    '&.open': {
      backgroundColor: theme.evPalette.ocean[800],
    },
    '&>.myev-MuiButton-label': {
      display: 'flex',
      gap: '8px',
    },
  },
  orderDetailsAddress: {
    display: 'flex',
    padding: '10px 0px',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    columnGap: '8px',
    alignSelf: 'stretch',
    flexWrap: 'wrap',
    '@media (min-width: 640px)': { gap: '10px' },
  },
  blueprintOrderDetailsId: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '10px 0px',
    flexWrap: 'wrap',
    '@media (min-width: 640px)': {
      gap: '10px',
      flexDirection: 'row',
      alignItems: 'flex-end',
    },
  },
  blueprintOrderDetails: {
    gap: '16px',
    padding: '24px',
  },
  orderDetailsColumn: {
    color: theme.evPalette.charcoal[600],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },
  trueDesignButton: {
    width: 'fit-content',
    height: '32px',
    '&>.myev-MuiButton-label': {
      display: 'flex',
      gap: '8px',
    },
    '@media (max-width: 640px)': {
      width: '100%',
      margin: '16px 0',
    },
  },
  skeletonLoader: {
    borderRadius: '6px',
    flexShrink: 0,
  },
  backButton: {
    width: 'fit-content',
    '&>.myev-MuiButton-label': {
      display: 'flex',
      gap: '8px',
    },
  },
  headerButtons: {
    display: 'flex',
    gap: '16px',
    width: '100%',
    alignItems: 'center',
    flexDirection: 'column-reverse',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      width: 'fit-content',
    },
  },
  mapContainer: {
    width: '100%',
    '@media (min-width: 640px)': {
      width: '50%',
      '@media (min-width: 1024px)': {
        width: '40%',
      },
    },
  },
  productContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '@media (min-width: 1024px)': {
      flexDirection: 'row',
      gap: '24px',
    },
  },
  upgradeButton: {
    '@media (max-width: 1024px)': {
      marginLeft: '-20px',
    },
  },
}));
